<template>
  <v-container>
    <v-row data-aos="fade-down" wrap>
      <Indicadores1 :items="items" />
    </v-row>
    <v-row> </v-row>
    <v-row wrap>
      <v-col cols="112" xs="12" sm="12" md="12">
        <ChartVentas
          data-aos="fade-right"
          :title="'Total facturado por mes'"
          :modo="modoChartVentas"
          :array="arrProp"
        />
      </v-col>
      <v-col cols="112" xs="12" sm="12" md="6">
        <ChartClientes data-aos="fade-left" :modo="modoChartClientes" />
      </v-col>
      <!-- <v-col cols="112" xs="12" sm="12" md="6">
        <ChartBestClientes data-aos="fade-left" :modo="modoChartBestClientes" />
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
import bus from "@/EventBus";
import moment from "moment";
import { mapState, mapActions } from "vuex";
import ChartVentas from "../components/base/charts/ChartVentas";

export default {
  data() {
    return {
      modoChartVentas: "column",
      modoChartClientes: "pie",
      modoChartBestClientes: "variablepie",
      arrProp: [],
      ventasA: [],
      ventasB: [],
      pedidosA: [],
      pedidosB: [],
      items: [
        {
          color: "#a169cb",
          cuantity: "",
          title: "Pedidos Almacén",
          artist: "Pedidos actuales",
        },
        {
          color: "#a169cb",
          cuantity: "",
          title: "Pedidos Distribución",
          artist: "Pedidos actuales",
        },
        {
          color: "#a169cb",
          cuantity: "",
          title: "Ventas Almacén",
          artist: "Cantidad",
        },

        {
          color: "#a169cb",
          cuantity: "",
          title: "Ventas Distribución",
          artist: "Cantidad",
        },
      ],
    };
  },
  created() {
    moment.locale("es");
    this.getClientes(this.token);
    this.llamarReporte();
    // this.getVentasDiarias(this.token);
  },
  mounted() {
    this.diferenciarVentas();
  },
  components: {
    Indicadores1: () => import('../components/dashboard/Indicadores'),
    Indicadores2: () => import('../components/dashboard/Indicadores2'),
    VentasReporte: () => import('../components/ReporteVenta'),
    // ChartBestClientes: () => import('../components/base/charts/ChartBestClientes'),
    ChartClientes: () => import('../components/base/charts/ChartClientes'),
    ChartVentas: () =>
      new Promise((resolve) => {
        setTimeout(() => {
          resolve(ChartVentas);
        }, 3000);
      }),
  },
  computed: {
    ...mapState("usuarioNamespace", ["token"]),
    ...mapState("clienteNamespace", ["clientes"]),
    ...mapState("ventasNamespace", [
      "ventas",
      "reporteVentas",
      "ventasDiarias",
    ]),
  },
  methods: {
    ...mapActions("ventasNamespace", [
      "getVentas",
      "getReporte",
      "getVentasDiarias",
    ]),
    ...mapActions("clienteNamespace", ["getClientes"]),
    async llamarReporte() {
      this.arrProp = [];
      await this.getReporte(this.token);
      this.arrProp = this.reporteVentas;
    },
    async diferenciarVentas() {
      await this.getVentas(this.token);
      this.ventas.forEach((e) => {
        if (e.entrega != false) {
          e.negocio == 1 ? this.ventasA.push(e) : this.ventasB.push(e);
        } else {
          e.negocio == 1 ? this.pedidosA.push(e) : this.pedidosB.push(e);
        }
      });
      this.totalVentasAlmacen();
      this.totalVentasDistribucion();
      this.totalPedidosAlmacen();
      this.totalPedidosDistribucion();
    },
    totalPedidosAlmacen() {
      this.items[0].cuantity = this.pedidosA.length;
    },
    totalPedidosDistribucion() {
      this.items[1].cuantity = this.pedidosB.length;
    },
    totalVentasAlmacen() {
      this.items[2].cuantity = this.ventasA.length;
    },
    totalVentasDistribucion() {
      this.items[3].cuantity = this.ventasB.length;
    },
    // mejorClienteReparto() {
    //   let ventasReparto = this.ventasB;
    //   let clientes = this.clientes;
    //   let sum = 0;
    //   let top = [];
    //   let mes = moment().month();
    //   if (mes === moment().month()) {
    //     clientes.forEach((c) => {
    //       ventasReparto.forEach((v) => {
    //         if (c._id == v.persona._id) {
    //           top.push(v.persona);
    //         }
    //       });
    //     });
    //   } else {
    //   }
    // },
  },
};
</script>
